import { Badge, Card, Col } from 'reactstrap';
// import { LearningGridData } from "../../../../data/miscellaneous/Learning";
import { Image } from '../../../../coreComponents/Image';
import { CourseData } from '../../../../types/Tables';
import { Link } from 'react-router-dom';
import { baseLang, secondsToHhMmSs } from '../../../../lib/utils';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const BlogBoxGrid = ({ coursesData }: { coursesData: CourseData[] }) => {
  const { t, i18n } = useTranslation();
  const pageLang = baseLang(i18n.language);
  const getTranslate = (element: 'name' | 'description', lang: string, component: CourseData) => {
    if (lang === 'en') {
      return component[element];
    } else {
      const translation = component.translations?.find((el) => el.lang === lang);
      if (!translation) {
        return component[element];
      }
      return translation[element];
    }
  };

  return (
    <>
      {coursesData.map((item) => {
        const duration = item.totalDuration ? item.totalDuration : 0;
        const showPendingStatus = item.courseStateStatus === 'pending';
        const isCourseUnavailable = item.userCourseStatus === null;
        const showBlockingBadge = showPendingStatus || isCourseUnavailable;
        const badgeText = showPendingStatus
          ? t('courses.coursesStatus.pending')
          : isCourseUnavailable
            ? t('courses.coursesStatus.unavailable')
            : '';
        const badgeColor = showPendingStatus ? 'info' : isCourseUnavailable ? 'danger' : '';
        return (
          <Col xl="6" sm="12" key={item.id}>
            <Card className="position-relative overflow-hidden">
              <div
                className={`${showBlockingBadge ? 'd-flex position-absolute z-2 top-0 left-0 w-100 h-100 bg-black opacity-25  pe-none' : 'd-none'}`}
              />
              {showBlockingBadge && (
                <div
                  className="position-absolute z-3 pe-none"
                  style={{
                    top: 10,
                    left: 10,
                    zIndex: 1,
                  }}
                >
                  <Badge
                    pill={true}
                    color={badgeColor}
                    key={item.id}
                    // className={`${item.badgeClass ? item.badgeClass : className}`}
                    className="fs-6"
                  >
                    {badgeText}
                  </Badge>
                </div>
              )}

              <Link
                to={`details/${item.id}`}
                className={`${showBlockingBadge ? 'pe-none greyscale' : 'pe-auto'}`}
              >
                <div className="blog-box blog-grid text-center product-box position-relative">
                  {item.courseStateStatus === 'active' && item.status && (
                    <div
                      className="position-absolute"
                      style={{
                        top: 10,
                        left: 10,
                        zIndex: 1,
                      }}
                    >
                      {item.status && (
                        <Badge
                          pill={true}
                          color={`${item.status === 'completed' ? 'success' : 'warning'}`}
                          key={item.id}
                          // className={`${item.badgeClass ? item.badgeClass : className}`}
                          className="fs-6"
                        >
                          {item.status === 'completed'
                            ? t('courses.courseStudyStatus.completed')
                            : t('courses.courseStudyStatus.inProgress')}
                        </Badge>
                      )}
                    </div>
                  )}
                  <div className="product-img course-img">
                    <Image
                      className="img-fluid top-radius-blog"
                      src={`${process.env.REACT_APP_BACKEND_STATIC}/coursesPics/${item.courseImage}`}
                      alt=""
                    />
                    <div className="product-hover">
                      <ul>
                        <li>
                          <i className="icon-link"></i>
                        </li>
                        <li>
                          <i className="icon-import"></i>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="blog-details-main">
                    {item.courseStateStatus !== 'pending' && (
                      <ul className="blog-social justify-content-center">
                        <li>
                          <i className="icofont icofont-calendar"></i>
                          {item.createdAt
                            ? new Date(item.createdAt).toLocaleDateString('uk-UA', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric',
                              })
                            : '—'}
                        </li>

                        <li>
                          {' '}
                          <i className="icofont icofont-clock-time"></i> {secondsToHhMmSs(duration)}
                        </li>
                        <li>
                          <i className="icofont icofont-video"></i>{' '}
                          {item.categories.reduce((sum, cat) => sum + cat.lessons?.length, 0)}
                        </li>
                      </ul>
                    )}
                    <hr />
                    <p className="blog-bottom-details">{getTranslate('name', pageLang, item)}</p>
                    <p className="blog-bottom-details truncate-multiline-3">
                      {getTranslate('description', pageLang, item)}
                    </p>
                  </div>
                </div>
              </Link>
            </Card>
          </Col>
        );
      })}
    </>
  );
};
export default BlogBoxGrid;
